<script setup>
  import Button from 'primevue/button'

  import { useConfirmStore } from '../store/useConfirmStore'
  import ModalDialog from './modalDialog/ModalDialog.vue'

  const confirmStore = useConfirmStore()
</script>

<template>
  <ModalDialog
    v-model:visible="confirmStore.isOpen"
    :header="confirmStore.title"
    :severity="confirmStore.severity"
    :modal="true"
    :style="{ width: '400px' }"
    :closable="false"
  >
    <div class="confirm-modal-content">
      <div class="confirm-icon" :class="confirmStore.severity">
        <i
          :class="
            confirmStore.severity === 'error'
              ? 'pi pi-exclamation-triangle'
              : 'pi pi-question-circle'
          "
        ></i>
      </div>
      <p class="confirm-message">{{ confirmStore.message }}</p>
    </div>

    <template #footer>
      <div class="confirm-modal-footer">
        <Button
          :label="confirmStore.cancelLabel"
          text
          severity="secondary"
          @click="confirmStore.cancel"
        />
        <Button
          :label="confirmStore.confirmLabel"
          :severity="confirmStore.severity === 'error' ? 'danger' : 'primary'"
          autofocus
          @click="confirmStore.confirm"
        />
      </div>
    </template>
  </ModalDialog>
</template>

<style scoped>
  .confirm-modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1.5rem 0.5rem;
    text-align: center;
  }

  .confirm-icon {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.25rem;
    font-size: 2rem;
    background: light-dark(#f3f4f6, #374151);
    transition: transform 0.3s ease;
  }

  .confirm-modal-content:hover .confirm-icon {
    transform: scale(1.1);
  }

  .confirm-icon.info {
    color: var(--fm-ui-primary-color);
    background: light-dark(rgba(99, 102, 241, 0.1), rgba(99, 102, 241, 0.2));
  }

  .confirm-icon.error {
    color: var(--fm-ui-red-color);
    background: light-dark(rgba(220, 38, 38, 0.1), rgba(220, 38, 38, 0.2));
  }

  .confirm-message {
    font-size: 1.0625rem;
    font-weight: 500;
    color: light-dark(#1f2937, #f9fafb);
    line-height: 1.6;
    margin: 0;
  }

  .confirm-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    width: 100%;
    padding: 0.5rem 0;
  }
</style>
